// extracted by mini-css-extract-plugin
export default {"next-video-container":"t74qQ","selected-videos-container":"MI6KG","assets-container":"AVWll","search-container":"mXb2A","heading":"DFez0","spinner":"p7bIJ","staticVideoCard":"u7hqZ"};